/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link, } from 'react-router-dom';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  Box, Card, Typography, Modal,
  MenuItem,
  TextField,
  CardContent
} from "@mui/material";
import { appConstants } from "utils/appConstants";
import MDButton from 'components/MDButton';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import MDBox from 'components/MDBox';
import HelpIcon from '@mui/icons-material/Help';
import { CSVLink } from "react-csv";
import { getScreenRight } from 'utils/generic';
import { blank } from 'utils/generic';
import { getPaymentAndRevenueReport } from 'utils/superAdminApi';
import { showResMsg } from 'utils/generic';
import { genericMessage } from 'utils/genericMessages';
import PageTitle from 'examples/PageTitle/PageTitle';
import { BTable } from 'components/BTable/BTable';
import { getSubcriptionPlan } from 'utils/superAdminApi';
import { useDispatch } from 'react-redux';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  display: 'grid',
  justifyContent: 'center'
};

function PaymentReport() {
  const [subsciptionPlan, setSubscriptionPlan] = useState("")
  const [showFilters, setShowFilters] = useState(false);
  const [rows, setRows] = useState([])
  const [showModel, setShowModel] = useState(false)
  const [tabledata, setTableData] = useState([]);
  const [resetClicked, setResetClicked] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [customerReload, setCustomerReload] = useState(false)
  const [totalRows, setTotalRows] = useState(0);
  const dispatch = useDispatch();

  const [values, setValues] = React.useState({
    initialValue: '',
    finalValue: 10,
    businessUserStatus: 'Active',
    _id: '',
    searchParameterList: ['clientName', 'paymentDateString', 'invoiceDateString', 'invoiceNumber', 'invoiceAmountString',
      'transactionType', 'invoiceStatus', 'planNameWithTrialUser', 'activationDateString', 'expiryDateString', 'emailAddress',
      'mobileNumber', 'city', 'paymentAmountString', 'country', 'state', 'subscriptionPlanFormatted'],
    searchParameter: '',
    state: '',
    userStatus: '',
    country: '',
    subsciptionPlanDD: '',
    activationDuration: '',
    expiryDuration: '',
    cancelDuration: '',
    invoiceDuration: '',
    paymentDuration: '',
    customSortOrder: '',
    paymentDate: "",
    invoiceDate: "",
    page: appConstants.page,
    limit: appConstants.limit,
    sortingType: "",
    sortingField: "",
  });

  const headers = [
    { label: "ClentName", key: "clientName" },
    { label: "Payment Date", key: "paymentDateString" },
    { label: "Payment Amount", key: "paymentAmount" },
    { label: "Invoice Date", key: "invoiceDateString" },
    { label: "Invoice Number", key: "invoiceNumber" },
    { label: "Invoice Amount", key: "invoiceAmount" },
    { label: "Transaction Type", key: "transactionType" },
    { label: "Invoive Status", key: "invoiceStatus" },
    { label: "Subsciption Plan", key: "subscriptionPlan" },
    { label: "Activation Date", key: "activationDateString" },
    { label: "Expiry Date", key: "expiryDateString" },
    { label: "Email Address", key: "emailAddress" },
    { label: "Mobile Number", key: "mobileNumber" },
    { label: "City", key: "city" },
    { label: "County", key: "country" },
    { label: "State", key: "state" },


  ];

  function exportSwal() {
    setShowModel(false)
    showResMsg(genericMessage.dataExportedSucces, 1000, true)
  }
  useEffect(() => {
    fetchPaymentReport();
  }, [customerReload])

  useEffect(() => {
    fetchSubcriptionPlan();
    getRight()
  }, [])

  async function getRight() {
    let right = await getScreenRight("Payment Report")
    if (right === "Full Access")
      setDisableColor(false)
    else setDisableColor(true)
  }


  const fetchPaymentReport = () => {
    console.log("values", values)
    getPaymentAndRevenueReport(values, (data) => {
      setTotalRows(data.Result_Output.clientData.totalDocs)
      setRows(data.Result_Output.clientData.docs);
      setTableData(data.Result_Output.exportData);
    }, dispatch)
  };




  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };


  let fetchSubcriptionPlan = async () => {
    getSubcriptionPlan(values, (data) => {
      setSubscriptionPlan(data.Result_Output);
    })
  };

  const FilterData = async () => {
    fetchPaymentReport();


  };

  const ResetData = async () => {
    setValues((prevValues) => ({
      ...prevValues,
      paymentDate: "",
      invoiceDate: "",
      subsciptionPlanDD: "",
      searchParameter: "",
      invoiceDuration: '',
      paymentDuration: '',
      page: appConstants.page,
      limit: appConstants.limit,
      sortingType: "",
      sortingField: "",
    }))
    setResetClicked(true);
  };

  useEffect(() => {
    if (resetClicked) {
      fetchPaymentReport();
      setResetClicked(false);
    }
  }, [resetClicked]);


  let SubcriptionPlanList = (subsciptionPlan).length > 0
    && (subsciptionPlan).map((item, i) => {
      return (
        <MenuItem key={i} value={item.planName}>{item.planName}</MenuItem>
      )
    }, this);

  const handlePageChange = page => {
    values.page = page;
    setCustomerReload(!customerReload)
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage
    setCustomerReload(!customerReload)
  };
  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
    setCustomerReload(!customerReload)
  };
  const paymentCol = [
    {
      name: "Payment Date",
      selector: row => row.paymentDateString,
      sortable: true,
      sortField: 'paymentDate',
    },
    {
      name: "Payment Amount",
      selector: row => row.paymentAmount,
      sortable: true,
      sortField: 'paymentAmount',
    },
    {
      name: "Invoice Date",
      selector: row => row.invoiceDateString,
      sortable: true,
      sortField: 'invoiceDateString',
    },
    {
      name: "Invoice Number",
      selector: row => row.invoiceNumber,
      sortable: true,
      sortField: 'invoiceNumber',
    },
    {
      name: "Transaction Type",
      selector: row => row.transactionType,
      sortable: true,
      sortField: 'transactionType',
    },

    {
      name: "Invoice Status",
      selector: row => row.invoiceStatus,
      sortable: true,
      sortField: 'invoiceStatus',
    },

    {
      name: "Subscription Plan",
      selector: row => row.subscriptionPlan,
      sortable: true,
      sortField: 'subscriptionPlan',
    },
    {
      name: "Activation Date",
      selector: row => row.activationDateString,
      sortable: true,
      sortField: 'activationDate',
    },
    {
      name: "Expiry Date",
      selector: row => row.expiryDateString,
      sortable: true,
      sortField: 'expiryDate',
    },

  ]


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="Payments Report" />
          <Grid container columnSpacing={2} px={2} mt={1} alignItems="center" display="flex" justifyContent="right">
            <Grid item xs={12} md={4} spacing={2} lg={1.4} >
              <MDButton
                className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                color={disableColor ? "secondary" : "warning"}
                fullWidth
                onClick={disableColor ? blank : () => setShowFilters(!showFilters)}

              >
                {showFilters ? 'Hide Filters' : 'Set Filters'}

              </MDButton>
            </Grid>
            <Grid item xs={12} md={4} spacing={2} lg={1.4} >
              <MDButton
                className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                color={disableColor ? "secondary" : "success"}
                fullWidth
                onClick={disableColor ? blank : () => { setShowModel(true) }}
              >
                Export

              </MDButton>
            </Grid>
          </Grid>
          {showFilters && (

            <MDBox>
              <Grid item xs={12} >
                <MDBox px={1} pt={1}>
                  <Grid container columnSpacing={5}> <Grid item xs={12} lg={2.3}>
                    <MDBox mb={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="userStatus">Payment Date </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          style={{ minHeight: "3em" }}
                          label="Payment Date "
                          value={values.paymentDuration}
                          onChange={handleChange("paymentDuration")}

                        >
                          <MenuItem value="Today"> Today </MenuItem>
                          <MenuItem value="last7Days"> Last Week  </MenuItem>
                          <MenuItem value="last30Days"> Last 1 Month </MenuItem>
                          <MenuItem value="last6Months"> Last 6 Months </MenuItem>
                          <MenuItem value="last1Year"> Last 1 Year </MenuItem>
                          <MenuItem value="MoreThenYear"> More Than 1 Year </MenuItem>

                        </Select>
                      </FormControl>
                    </MDBox>
                  </Grid> <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="userStatus">Invoice Date</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Invoice Date"
                            value={values.invoiceDuration}
                            onChange={handleChange("invoiceDuration")}

                          >
                            <MenuItem value="Today"> Today </MenuItem>
                            <MenuItem value="last7Days"> Last Week  </MenuItem>
                            <MenuItem value="last30Days"> Last 1 Month </MenuItem>
                            <MenuItem value="last6Months"> Last 6 Months </MenuItem>
                            <MenuItem value="last1Year"> Last 1 Year </MenuItem>
                            <MenuItem value="MoreThenYear"> More Than 1 Year </MenuItem>

                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="userStatus">Subscription Plan</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Subscription Plan"
                            value={values.subsciptionPlanDD}
                            onChange={handleChange("subsciptionPlanDD")}

                          >
                            {SubcriptionPlanList}

                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={2.3}>
                      <MDBox><TextField
                        type="text"
                        label="Search"
                        variant="outlined"
                        fullWidth
                        placeholder="Search..."
                        size="medium"
                        value={values.searchParameter}
                        onChange={handleChange("searchParameter")}

                      />

                      </MDBox>

                    </Grid>


                    <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                      <Link to={"/paymentReport"}>
                        <MDButton
                          className="btn-block center-container-btn btn-warning btn-back rightSpace"
                          color="warning"
                          fullWidth
                          onClick={ResetData}
                        >
                          Reset
                        </MDButton>
                      </Link>
                    </Grid>
                    <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                      <MDButton
                        rel="noreferrer"
                        variant="gradient"
                        color="success"
                        fullWidth
                        onClick={FilterData}
                      >
                        Apply
                      </MDButton>
                    </Grid>


                  </Grid>
                </MDBox>
              </Grid>
            </MDBox>
          )}
          <CardContent>
            <BTable

              columns={paymentCol}
              data={rows}
              selectableRows={false}
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}

            />
          </CardContent>

        </Card>





        {showModel &&
          <Modal
            open={showModel}
            onClose={() => setShowModel(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Card sx={style}>
              <Box>
                <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontSize: "40px", textAlign: "center" }}>
                  <HelpIcon style={{ color: "red" }} />
                </Typography>
                <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black" }}>
                  Would you like to export this record?
                </Typography>
                <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                  <>
                    <MDButton color="warning" onClick={() => { setShowModel(false) }} sx={{ width: "64px", textTransform: "capitalize" }}>
                      No
                    </MDButton>
                  </>
                  &nbsp; &nbsp;
                  <>
                    <CSVLink data={tabledata} headers={headers} filename={"Payment Report (" + (new Date().toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })) + ") .csv"}>
                      <MDButton color="error" onClick={() => { exportSwal() }} sx={{ width: "64px", textTransform: "capitalize" }}>
                        Yes
                      </MDButton>
                    </CSVLink>
                  </>
                </Grid>
              </Box>
            </Card>
          </Modal>
        }
      </div>
    </DashboardLayout>
  );
}
export default PaymentReport;
